import { createContext } from '@lyearn/core/utils/context';
import { onQuizCreatorAction } from '@/modules/corporate/modules/quiz/views/QuizEditor/hooks/useQuizEditor/actions';
import { QuizEditorUiState } from '@/modules/corporate/modules/quiz/views/QuizEditor/hooks/useQuizEditor/types';
import { UpdateQuestionEntity } from '@/types/schema';

import { QuizEditorDetailsFragment } from '../../graphql/fragments/generated/QuizEditorContent';

interface ContextValue {
  isQuizPublished?: boolean;
  canEditSections?: boolean;
  uiState: QuizEditorUiState;
  quiz: QuizEditorDetailsFragment;
  questions: UpdateQuestionEntity[];
  publishedQuestionById: Record<string, Pick<UpdateQuestionEntity, 'options'>>;
  onAction: onQuizCreatorAction;
  refetchQuiz: () => void;
}

export const [QuizEditorContextProvider, useQuizEditorContext] =
  createContext<ContextValue>('QuizEditor');
